(function () {
  'use strict';

  function parseFlavors(root) {
    var data = document.getElementById('rvx-blv2-data-' + root.id.replace('rvx-blv2-', ''));
    try { return JSON.parse(data ? data.textContent : '[]') || []; }
    catch (error) { console.error('RVX Buy Ladder V2: flavor data could not be parsed.', error); return []; }
  }

  function setMode(card, mode) {
    var buy = card.querySelector('[data-buy]');
    if (!buy) return;
    card.dataset.mode = mode;
    card.querySelectorAll('[data-mode-btn]').forEach(function (button) {
      var active = button.dataset.modeBtn === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.panel !== mode;
    });
    var label = buy.querySelector('[data-button-label]');
    if (label) label.textContent = mode === 'sub' ? buy.dataset.subLabel : buy.dataset.onceLabel;
    buy.setAttribute('href', mode === 'sub' ? buy.dataset.subUrl : buy.dataset.onceUrl);
  }

  function initializeRoot(root) {
    if (!root || root.dataset.rvxV2Ready === 'true') return;
    root.dataset.rvxV2Ready = 'true';
    root.querySelectorAll('[data-card]').forEach(function (card) {
      card.querySelectorAll('[data-mode-btn]').forEach(function (button) {
        button.addEventListener('click', function () { setMode(card, button.dataset.modeBtn); });
      });
      setMode(card, 'sub');
    });
  }

  function initializeAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-rvx-buy-ladder-v2]')) initializeRoot(context);
    context.querySelectorAll('[data-rvx-buy-ladder-v2]').forEach(initializeRoot);
  }

  document.addEventListener('click', function (event) {
    var buy = event.target.closest('[data-rvx-buy-ladder-v2] [data-buy]');
    if (!buy) return;
    var card = buy.closest('[data-card]');
    var root = buy.closest('[data-rvx-buy-ladder-v2]');
    if (!card || !root) return;

    var flavors = parseFlavors(root);
    if (!flavors.length) return; // hard-coded deep link remains as fallback

    event.preventDefault();
    if (buy.classList.contains('is-loading')) return;
    buy.classList.add('is-loading');
    buy.setAttribute('aria-busy', 'true');

    var mode = card.dataset.mode || 'sub';
    var each = parseInt(buy.dataset.each, 10) || 1;
    var targetPct = parseInt(buy.dataset.subPct, 10) || 0;
    var planFilter = 'every month';

    var items = flavors.map(function (flavor) {
      var item = { id: Number(flavor.id), quantity: each };
      if (mode === 'sub') {
        var plans = (flavor.plans || []).filter(function (plan) {
          return !planFilter || String(plan.name || '').toLowerCase().indexOf(planFilter) !== -1;
        });
        var selected = null;
        plans.forEach(function (plan) { if (!selected && Number(plan.pct) === targetPct) selected = plan; });
        if (!selected) {
          plans.forEach(function (plan) {
            if (selected) return;
            var match = String(plan.name || '').match(/(\d+)\s*%/);
            if (match && parseInt(match[1], 10) === targetPct) selected = plan;
          });
        }
        if (!selected && plans.length) {
          selected = plans.slice().sort(function (a, b) {
            return Math.abs(Number(a.pct) - targetPct) - Math.abs(Number(b.pct) - targetPct);
          })[0];
        }
        if (selected && selected.id) item.selling_plan = Number(selected.id);
      }
      return item;
    });

    fetch(root.dataset.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data.status && Number(data.status) >= 400)) throw new Error(data.description || data.message || 'Unable to add bundle to cart.');
          return data;
        });
      })
      .then(function () { window.location.assign(root.dataset.checkoutUrl || '/checkout'); })
      .catch(function (error) {
        console.error('RVX Buy Ladder V2 checkout error:', error);
        buy.classList.remove('is-loading');
        buy.removeAttribute('aria-busy');
        window.location.assign(buy.getAttribute('href'));
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
